import { User } from "./User";

export type ReportingFrequencyEnum = "monthly" | "quarterly";
export type ProgramStatusEnum = "active" | "paused";
export type ProgressStatus = "on_track" | "behind" | "at_risk";

export interface ProgramCardProps {
  id: number;
  name: string;
  icon: string;
  status: "active" | "paused";
  projects: number;
  description: string;
  budget_spent: string;
  budget: string;
  completion_percentage: number;
  creator_id: number;
  onClick?: () => void;
  handleDelete: (programId: number) => void;
  handleEdit: (programId: number) => void;
  members?: { leader: boolean; user: User }[];
}

export interface MilestoneDisplay {
  id: string;
  name: string;
  description: string;
  start_date: Date;
  end_date: Date;
  status: ProgressStatus;
  responsible_user: User;
  created_at: Date;
}

export interface ProgramPayload {
  name: string;
  icon?: string;
  creator_id?: number; // typically user IDs
  description: string;
  budget_spent: string;
  budget: string;
  start_date: string; // ISO date format
  end_date: string; // ISO date format
  donors?: any;
  members: { leader: boolean; user: User }[];
  status: ProgramStatusEnum;
  completeion_percentage: number;
  reporting_frequency: ReportingFrequencyEnum | null;
  reportingFrequencyMonthly: boolean;
  reportingFrequencyQuarterly: boolean;
  currency_id: number;
}

export interface GoalPayload {
  id?: number;
  name: string;
  description: string;
  start_date: string;
  end_date: string;
  reporting_frequency: ReportingFrequencyEnum | null;
  program_id: string;
  project_ids: number[];
  projects: ProjectDropdownValue[];
  creator_id?: number;
  created_at?: string;
  reportingFrequencyMonthly: boolean;
  reportingFrequencyQuarterly: boolean;
}

export interface MilestonePayload {
  id?: number;
  name: string;
  description: string;
  start_date: string; // ISO date string (e.g., "2025-05-14")
  end_date: string;
  reporting_frequency: ReportingFrequencyEnum | null;
  template_id?: number | null;
  project_id: number;
  program_id: number;
  goal_id: number;
  responsible_user_id?: number | null;
  created_at?: string; // Optional, populated on fetch
  reportingFrequencyMonthly: boolean;
  reportingFrequencyQuarterly: boolean;
}

export interface ProjectDropdownValue {
  id: string;
  name: string;
}

export interface GoalDropdownValue {
  id: string;
  name: string;
}

export interface GoalItem {
  id: string;
  name: string;
  description: string;
  milestones: MilestoneDisplay[];
  start_date: string;
  end_date: string;
  reporting_frequency: string;
  projects: ProjectDropdownValue[];
  status: "on_track" | "behind" | "at_risk";
}

export interface DonorPayload {
  name: string;
  description?: string;
}

export interface Donor extends DonorPayload {
  id: number;
}

export interface DeleteProgramModalProps {
  isOpen: boolean;
  selectedProgram?: ProgramCardProps;
  onClose: () => void;
  onConfirm: () => void;
}

export interface DeleteEntityModalProps {
  isOpen: boolean;
  selectedEntity: { name?: string; title?: string } | null;
  onClose: () => void;
  onConfirm: () => void;
  titleText?: string;
  detailsText?: string;
  cancelClassName?: string;
  confirmClassName?: string;
  confirmText?: string;
  isLoading?: boolean;
}

export const statusColors: Record<ProgressStatus, string> = {
  on_track: "#10b981",
  behind: "#f59e0b",
  at_risk: "#ef4444",
};
